<template>
  <Tile
    v-if="blok"
    :key="blok.id"
    v-editable="blok"
    :alt="blok.alt !=='' ? blok.alt : null"
    :to="!blok.slug ? null : {path: blok.slug}"
    :src="src"
    :width="blok.width || null"
    :height="blok.height || null"
    :srcset="srcSet"
    :no-border-radius-mobile="true">
    <StoryblokComponent v-for="bodyBlok in blok.blocks" :key="bodyBlok._uid" :blok="bodyBlok" />
  </Tile>
</template>
<script setup>
import storyblokToCdn from '~/helpers/storyblok-to-cdn'
const props = defineProps({ blok: Object })

const src = computed(() => {
  if (!props.blok.images?.length) { return null }
  return storyblokToCdn(props.blok.images[0].filename)
})

const srcSet = computed(() => {
  if (!props.blok.images || props.blok.images.length <= 1) { return null }

  const breakpoints = ['800w', '1920w', '3000w']
  return props.blok.images.map((image, index) => {
    return `${storyblokToCdn(image.filename)} ${breakpoints[index]}`
  }).join(', ')
})
</script>
